// extracted by mini-css-extract-plugin
var _1 = "CalendarGridAgendaDayTitle-moduleCalendarGridAgendaDayTitle__vub4v";
var _2 = "CalendarGridAgendaDayTitle-moduletoday__eogsu";
export { _1 as "CalendarGridAgendaDayTitle", _2 as "today" }
